import { FormGroup, Validators } from "@angular/forms";
import { Lib } from "app/lib/lib";

export class User {
  id?: number;
  tenantId?: number;
  branchId?: number;
  accountId?: number;
  personId?: number;
  userName?: string;
  fullName?: string;
  departments?: string[];
  title?: string;
  email?: string;
  mobile?: string;
  linkedin?: string;
  addressId?: number;
  publishProfile?: boolean;
  emailVerified?: boolean;
  theme?: string;
  lang?: string;
  lastLogOn?: Date;
  type?: UserTypeEnum;
  status?: UserStatusEnum;
  data?: any;
  createdById?: number;
  updatedById?: number;
  createdOn?: Date;
  updatedOn?: Date;
  desc?: string;
  imageId?: number;
  token?: string;  // non-serialized
  roles?: number[];
  privilages?: number[];
  newUserPassword?: string;
  reTypeNewUserPassword?: string;

  static createForm(data?: User, reqFieldsCSV?: string) {
    let form: FormGroup = Lib.instance._fb.group({
      id: [data?.id ?? 0],
      userName: [data?.userName ?? null, Validators.required],
      fullName: [data?.fullName ?? null],
      tenantId: [data?.tenantId ?? null],
      branchId: [data?.branchId ?? null],
      status: [data?.status ?? null],
      type: [data?.type ?? null, Validators.required],
      desc: [data?.desc ?? null],
      title: [data?.title ?? null],
      imageId: [data?.imageId ?? null],
      email: [data?.email ?? null],
      mobile: [data?.mobile ?? null],
      departments: [data?.departments ?? null],
      linkedin: [data?.linkedin ?? null],
      addressId: [data?.addressId ?? null],
      publishProfile: [data?.publishProfile ?? null],

      newUserPassword: [data?.newUserPassword ?? null],
      reTypeNewUserPassword: [data?.reTypeNewUserPassword ?? null],

      emailVerified: [data?.emailVerified ?? null],
      lastLogOn: [data?.lastLogOn ?? null],

      createdById: [data?.createdById ?? null],
      updatedById: [data?.updatedById ?? null],
      createdOn: [data?.createdOn ?? null],
      updatedOn: [data?.updatedOn ?? null],
      roles: [data?.roles ?? null],
      privilages: [data?.privilages ?? null],
    });

    if (form.get('status')?.value === 0) form.disable();
    if (form.get('status')?.value === 1) form.enable();

    reqFieldsCSV?.split(',').map(e => e.trim()).forEach(fieldName => {
      form.get(fieldName)?.addValidators(Validators.required);
    });

    return form;
  }


  constructor(data?: any) { if (data) { for (const key in data) { try { this[key] = data[key]; } catch (error) { } } } }

  public get statusName() {
    switch (this.status) {
      case UserStatusEnum.Active: return 'Etkin'; break;
      case UserStatusEnum.Active: return 'Devre dışı'; break;
      default: return `${this.status}`; break;
    }
  }

  public get _search(): string {
    var s = ``;
    s = `${this.fullName ?? ''}-${this.userName ?? ''}`;
    s = Lib.convert2EnglishCharset(s);
    s = s.toLowerCase().trim();
    return s;
  }
}

export class UserLookupModel {
  name?: string;
  type?: UserTypeEnum;
}

export enum UserStatusEnum {
  Inactive = 0,
  Active = 1,
}

export enum UserTypeEnum {
  WebVisitor = 0,
  SYSTEM_ADMIN = 255,
  TenantAdmin = 200,
  Dealer = 100,
  AccountAdmin = 10,
  AccountUser = 11,
  Production = 12,
  Trans = 13,
}
